import {
    Injectable,
    ComponentFactoryResolver,
    Injector,
    ApplicationRef,
    InjectionToken,
    ElementRef,
    ComponentRef,
    StaticProvider
} from '@angular/core';
import { ComponentPortal, DomPortalOutlet } from '@angular/cdk/portal';

export const DYNAMIC_COMPONENT_CONFIG = new InjectionToken<{}>('DYNAMIC_COMPONENT_CONFIG');

@Injectable()
export class EuiDynamicComponentService {

    private portalHost: DomPortalOutlet;
    private portal: ComponentPortal<any>;
    private portalComponentInstance: ComponentRef<any>;

    constructor(
        private componentFactoryResolver: ComponentFactoryResolver,
        private injector: Injector,
        private appRef: ApplicationRef,
    ) { }

    public attach(component: any, el?: ElementRef, config?: any) {

        // Create a portalHost from a DOM element
        this.portalHost = new DomPortalOutlet(
            el ? el.nativeElement : document.body,
            this.componentFactoryResolver,
            this.appRef,
            this.injector,
        );

        // Locate the component factory for the ComponentToIncludeDynamicallyComponent
        this.portal = new ComponentPortal(component, null, config ? this.createInjector(config) : null);

        // Attach portal to host
        this.portalComponentInstance = this.portalHost.attach(this.portal);

        return { portalHost: this.portalHost, portal: this.portal, portalComponentInstance: this.portalComponentInstance };
    }

    public detach(portalHostRef: DomPortalOutlet) {
        portalHostRef.detach();

        this.portalHost = null;
        this.portal = null;
        this.portalComponentInstance = null;
    }

    private createInjector(data: any): Injector {
        const injectorTokens: StaticProvider = [{ provide: DYNAMIC_COMPONENT_CONFIG, useValue: data }];
        return Injector.create({
            parent: this.injector,
            providers: injectorTokens
        });
    }

}
